import { render, staticRenderFns } from "./SectionGalleryRedMachine.vue?vue&type=template&id=3ad3bc88"
import script from "./SectionGalleryRedMachine.vue?vue&type=script&lang=ts"
export * from "./SectionGalleryRedMachine.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports